/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import cns from 'classnames';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis } from 'recharts';
import TrackPlayerSlideComponent from '../../hocs/TrackPlayerSlideComponent';
import RichTextDisplay from '../../components/RichTextDisplay';
import WorkspaceSlideHeader from './WorkspaceSlideHeader';

class ThisOrThatResultChart extends Component {
    static propTypes = {
        onChange: PropTypes.func,
        content: PropTypes.shape({
            resultsToShow: PropTypes.number,
            ignoredCategories: PropTypes.array,
            description: PropTypes.string
        }).isRequired,
        name: PropTypes.string.isRequired,
        canMoveToNext: PropTypes.func,
        isActivity: PropTypes.bool,
        currentUser: PropTypes.object.isRequired,
        completedData: PropTypes.object,
        abQuestionContent: PropTypes.shape({
            categories: PropTypes.array,
            questions: PropTypes.array
        }).isRequired,
        abQuestionData: PropTypes.object.isRequired,
        nextSectionName: PropTypes.string,
        sectionId: PropTypes.string,
        sectionItemId: PropTypes.string,
        hideBookmark: PropTypes.bool,
        sendWorkspaceSegementEvent: PropTypes.func,
        isRefSheet: PropTypes.bool,
    };

    /**
     *
     * @return {Array}
     * @private
     */
    _createResults = () => {
        const { abQuestionData, abQuestionContent, content } = this.props;
        let ignored = {};
        if (content.ignoredCategories) {
            ignored = get(content, 'ignoredCategories', []).reduce((acc, cat) => {
                acc[cat] = true;
                return acc;
            }, {});
        }

        const result = get(abQuestionContent, 'categories', []).reduce((acc, cat) => {
            if (!ignored[cat.id]) {
                acc[cat.id] = {
                    id: cat.id,
                    name: cat.name,
                    totalCount: 0,
                    userCount: 0
                };
            }
            return acc;
        }, {});

        (get(abQuestionContent, 'questions', []) || []).forEach((question) => {
            if (question.A && question.B) {
                if (result[question.A.categoryId]) {
                    result[question.A.categoryId].totalCount += 1;
                }
                if (result[question.B.categoryId]) {
                    result[question.B.categoryId].totalCount += 1;
                }
            }
            if (question.answers && question.answers.length) {
                for (let i = 0; i < question.answers.length; i += 1) {
                    if (result[question.answers[i].categoryId]) {
                        result[question.answers[i].categoryId].totalCount += 1;
                    }
                }
            }
        });
        const retrievedQuestionData = get(abQuestionData, 'data', {}) || {};
        Object.values(retrievedQuestionData).forEach((id) => {
            if (result[id]) {
                result[id].userCount += 1;
            }
        });

        return Object.values(result).map((cat) => ({ subject: cat.name, A: cat.userCount, fullMark: cat.totalCount }));
    };

    UNSAFE_componentWillMount() {
        const { canMoveToNext, onChange, completedData } = this.props;
        canMoveToNext(true);
        const isCompleted = true;

        const isAnswered = true;
        onChange(get(completedData, 'data', null), isCompleted, isAnswered);
    }

    render() {
        const {
            name,
            nextSectionName,
            content,
            currentUser,
            isActivity = false,
            sectionId,
            sectionItemId,
            hideBookmark,
            sendWorkspaceSegementEvent,
            isRefSheet = false,
        } = this.props;

        const data = this._createResults();
        let chartPosition = {
            cx: 400,
            cy: 250,
            or: 150,
            w: 800,
            h: 500
        };

        if (isActivity) {
            chartPosition = {
                cx: 150,
                cy: 125,
                or: 100,
                w: 300,
                h: 250
            };
        }
        if (data.length < 3) {
            const { length } = data;
            for (let i = 0; i < 3 - length; i += 1) {
                data.push({ subject: '', A: 0.2, fullMark: 0 });
            }
        }

        return (
            <div>
                <WorkspaceSlideHeader
                    headerText={name}
                    currentSectionItemId={sectionItemId}
                    currentSectionId={sectionId}
                    currentUser={currentUser}
                    hideBookmark={hideBookmark}
                    isRefSheet={isRefSheet}
                />
                <div className={cns('thisOrThatResultChart', 'playerContent')}>
                    <RichTextDisplay
                        className={'playerDescription'}
                        htmlToDisplay={content.description}
                        currentUser={currentUser}
                        nextSectionName={nextSectionName}
                    />
                    <RadarChart
                        cx={chartPosition.cx}
                        cy={chartPosition.cy}
                        outerRadius={chartPosition.or}
                        width={chartPosition.w}
                        height={chartPosition.h}
                        data={data}
                    >
                        <Radar
                            name={`${currentUser.firstName} ${currentUser.lastName}`}
                            dataKey={'A'}
                            stroke={'#CF2872'}
                            fill={'#CF2872'}
                            fillOpacity={0.6}
                        />
                        <PolarGrid />
                        <PolarAngleAxis dataKey={'subject'} />
                        <PolarRadiusAxis />
                    </RadarChart>
                </div>
            </div>
        );
    }
}

export const ThisOrThatResultChartComponent = ThisOrThatResultChart;
export default TrackPlayerSlideComponent(ThisOrThatResultChart);
